import AppConstants from 'constants/AppConstants';

export function toggleNavSearch(show: boolean): BaseTockAction {
  return {
    type: AppConstants.NAV_SEARCH_TOGGLE,
    payload: show,
  };
}

export function toggleMenu(): BaseTockAction {
  return {
    type: AppConstants.MENU_TOGGLE,
  };
}

export function closeMenu(): BaseTockAction {
  return {
    type: AppConstants.MENU_CLOSE,
  };
}

export function closeLoyaltyProgramLoginModal(): BaseTockAction {
  return {
    type: AppConstants.CLOSE_LOYALTY_PROGRAM_LOGIN_MODAL,
  };
}

export function openLoyaltyProgramLoginModal(): BaseTockAction {
  return {
    type: AppConstants.OPEN_LOYALTY_PROGRAM_LOGIN_MODAL,
  };
}

export function setConfirmSelectionDialogVisible(visibility: boolean): BaseTockAction {
  return {
    type: AppConstants.CONFIRM_SELECTION_SET_DIALOG_VISIBILE,
    payload: visibility,
  };
}
